import {Link} from 'react-router'
import styles from './style.css'

export default class SignIn extends React.Component {
  shouldComponentUpdate (nextProps, nextState) {
    return false
  }

  render () {
    return (
      <div>
        <div className={styles.bold}>
          SIGN IN TO YOUR DASHBOARD
        </div>
        <hr />
        <div className='col-md-8 no-padding'>
          Sign in to your Moka dashboard to manage your store
        </div>
        <div className='col-md-4'>
          <Link to='/login' className='btn btn-primary pull-right sign-in'>
            Sign In
          </Link>
        </div>
        <br />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/pages/RegisterComplete/SignIn.js